import { requestGet } from '@/utils/request';

const api = {
	LIST: '/op/lotto_list',
};

export async function lottoList(queryParams) {
	return requestGet(api.LIST, queryParams);
}
